import { createContext, useContext } from 'react';

export type PortalContainer = Element | DocumentFragment;

export const PortalContainerContext = createContext<PortalContainer | null>(null);

export function usePortalContainer(): PortalContainer | null {
    const portalContainer = useContext(PortalContainerContext);

    if (portalContainer) {
        return portalContainer;
    }

    if (typeof document === 'undefined') {
        return null;
    }

    return document.body;
}
